import React from 'react';
import moment from 'moment';
import Table from '../../CommonComponents/Table';
import EmptyState from './EmptyState';
import {
  HoverableTableRow,
  LoadingRow,
  RightAlignedTableCell,
  ShowMoreButton,
  ShowMoreCell,
  TableCell,
  TransactionDescriptionCell,
  TransactionsTable,
} from './styles';
import { Button } from '../../CommonComponents/OPL/Button/Button';
import { CategoriesMenu } from './CategoriesMenu/CategoriesMenu';

const TransactionsTableView = ({
  transactions,
  currentPage,
  totalPagesCount,
  fetchNextPage,
  expenseCategoryOptions,
  onExpenseCategoryChange,
  onEditTransactionClick,
  currentAccount,
  isFilterOpen,
  currentPeriodId,
}) => (
  <TransactionsTable isFilterOpen={isFilterOpen}>
    <Table.Header>
      <Table.Row>
        <TableCell>Date</TableCell>
        <TransactionDescriptionCell>Description</TransactionDescriptionCell>
        <TableCell>Category</TableCell>
        <RightAlignedTableCell>Amount</RightAlignedTableCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {transactions && transactions.length > 0 ? (
        transactions.map(transaction => {
          if (transaction.isLoading) {
            return (
              <Table.Row key={transaction.Id}>
                <TableCell>
                  <LoadingRow />
                </TableCell>
                <TransactionDescriptionCell>
                  <LoadingRow />
                </TransactionDescriptionCell>
                <TableCell>
                  <LoadingRow />
                </TableCell>
                <TableCell>
                  <LoadingRow />
                </TableCell>
              </Table.Row>
            );
          }
          return (
            <HoverableTableRow
              key={transaction.Id}
              onClick={() => onEditTransactionClick(transaction)}
            >
              <TableCell>{moment.utc(new Date(transaction.Date)).format('M/D/YYYY')}</TableCell>
              <TransactionDescriptionCell>{transaction.Description}</TransactionDescriptionCell>
              <TableCell onClick={event => event.stopPropagation()}>
                <CategoriesMenu
                  options={expenseCategoryOptions}
                  setOption={category => onExpenseCategoryChange(transaction, category.label)}
                  selectedOption={transaction.Category}
                >
                  <Button size="large" variant="subtleInactive" rightIcon="fa fa-angle-down">
                    {transaction.Category}
                  </Button>
                </CategoriesMenu>
              </TableCell>
              <RightAlignedTableCell>
                {transaction.NegativeBalance && '-'}$
                {ADV.util.formatValue(transaction.Balance, 'interest')}
              </RightAlignedTableCell>
            </HoverableTableRow>
          );
        })
      ) : (
        <Table.Row>
          <TableCell colSpan={5}>
            <EmptyState currentAccount={currentAccount} currentPeriodId={currentPeriodId} />
          </TableCell>
        </Table.Row>
      )}

      {currentPage < totalPagesCount && (
        <Table.Row>
          <ShowMoreCell>
            <ShowMoreButton onClick={fetchNextPage}>See more transactions</ShowMoreButton>
          </ShowMoreCell>
        </Table.Row>
      )}
    </Table.Body>
  </TransactionsTable>
);

export default TransactionsTableView;
